import MarketplaceCtrl from './marketplace.ctrl';
import routes from './marketplace.routes';

export default angular.module('cui.marketplace', ['ui.router'])
  .controller('MarketplaceCtrl', MarketplaceCtrl)
  .config(routes);



// WEBPACK FOOTER //
// ./source/client/pages/marketplace/index.js